<template>
  <div class="archived-tasks">
    <ag-table :data-source-api="getAllArchivedTasks" :grid-options="gridOptions" :permissions="{}" :rtl="false"
      :is-entities-response="false" />
  </div>
</template>

<script>
import { RepositoryFactory } from "../volunteer-repositories/volunteerRepositoryFactory";
import AgTable from "../../shared/shared-components/ag-grid/AgTableServerSide.vue";
import AgTableBtnCell from "../../shared/shared-components/ag-grid/AgTableBtnCell";
import utilities from "@/app/shared/utilities/index";

const tasksRepo = RepositoryFactory.get("tasksRepository");

export default {
  name: "ArchivedTasks",
  components: {
    AgTable,
    // eslint-disable-next-line vue/no-unused-components
    AgTableBtnCell,
  },
  data() {
    return {
      gridApi: null,
      gridOptions: null,
      taskTypes: {
        normal: "عادي",
        urgent: "مستعجل",
      },
    };
  },
  methods: {
    createColDefs() {
      let self = this;
      return [
        {
          headerName: "معرف الفرصة",
          field: "id",
          sortable: true,
          width: 200,
        },
        {
          headerName: "مجال الفرصة",
          field: "volunteeringField.name",
          filter: "agTextColumnFilter",
          sortable: true,
          width: 200,
        },
        {
          headerName: "العنوان",
          field: "title",
          filter: "agTextColumnFilter",
          width: 210,
          sortable: false,
        },
        {
          headerName: "الوصف",
          field: "description",
          filter: "agTextColumnFilter",
          width: 210,
          sortable: false,
        },
        {
          headerName: "من تاريخ",
          field: "startAt",
          filter: "agDateColumnFilter",
          width: 200,
          sortable: false,
          valueGetter: function getObject(data) {
            return data.data.startAt ? utilities.formatDate(data.data.startAt, "yyyy-MM-DD") : '-';
          },
        },
        {
          headerName: "إلى تاريخ",
          field: "endAt",
          filter: "agDateColumnFilter",
          width: 200,
          sortable: false,
          valueGetter: function getObject(data) {
            return data.data.endAt ? utilities.formatDate(data.data.endAt, "yyyy-MM-DD") : '-';
          },
        },
        {
          headerName: "النوع",
          field: "type",
          width: 210,
          sortable: false,
          valueGetter: function getObject(params) {
            return self.taskTypes[params.data.type] || "-";
          },
          filter: "agSetColumnFilter",
          filterParams: {
            values: Object.keys(self.taskTypes),
            valueFormatter: (params) =>
              self.taskTypes[params.value] || params.value,
          },
        },
        {
          headerName: "المواصفات",
          field: "specifications",
          width: 210,
          sortable: false,
        },
        {
          headerName: "الخطوات",
          field: "steps",
          width: 210,
          sortable: false,
        },
        {
          headerName: "عدد النقاط",
          field: "couponPoints",
          width: 210,
          sortable: false,
        },
        {
          headerName: "يمكن إرفاق ملف؟",
          field: "canUploadAttachment",
          width: 210,
          sortable: true,
          valueGetter: function getObject(params) {
            return params.data.canUploadAttachment
              ? "نعم"
              : "لا";
          },
        },
        {
          headerName: "الإجراءات",
          cellRendererFramework: AgTableBtnCell,
          sortable: false,
          valueGetter: function getObject(params) {
            return params.data;
          },
          cellRendererParams: {
            repeatRecord: function (task) {
              self.onRepeatTask(task);
            },
            viewRecordDetails: function (task) {
              self.$router.push({
                path: `/volunteers/tasks/${task.id}/sessions`,
                query: { archived: 'true' }
              });
            },
            actions: ["repeat", "view"],
            confirmRepeat: false,
            permissions: self.permissions,
          },
        },
      ];
    },
    async getAllArchivedTasks(query) {
      return await tasksRepo.fetchTasks(`${query}&filter=status||$in||completed&sort=createdAt,DESC`);
    },
    onRepeatTask(task) {
      this.$router.push({
        path: `/volunteers/tasks/${task.id}/duplicate`,
      });
    },
  },
  created() {
    this.gridOptions = {};
    this.gridOptions.columnDefs = this.createColDefs();
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
  },
};
</script>
